// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* img{\n     object-fit: cover;\n    object-position: center;\n  }\n  */", "",{"version":3,"sources":["webpack://./src/DemoPage/css/Clip.css"],"names":[],"mappings":"AAAA;;;;GAIG","sourcesContent":["/* img{\n     object-fit: cover;\n    object-position: center;\n  }\n  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
